import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Icon, Tooltip } from '@mui';
import { makeStyles } from '@material-ui/core/styles';
import * as colors from '@constants/colors';
import './form-tooltip.scss';

const useStyles = makeStyles(() => ({
  tooltip: {
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    padding: '1rem',
    maxWidth: 'none'
  }
}));

const tooltipContentStyle = {
  fontFamily: 'Roboto, sans-serif',
  fontSize: '0.8125rem',
  lineHeight: 1.5,
  color: colors.dotmapsBlack60,
  width: '18rem',
  pointerEvents: 'none'
};

const FormTooltip = ({ children }) => {
  const classes = useStyles();

  return (
    <div styleName="form-tooltip-container">
      <Tooltip
        title={<div style={tooltipContentStyle}>{children}</div>}
        placement="bottom-start"
        classes={{ tooltip: classes.tooltip }}
      >
        <span
          role="button"
          tabIndex={0}
          aria-label="Help"
          style={{ display: 'inline-flex', cursor: 'pointer' }}
        >
          <Icon
            color={colors.dotmapsBlack60}
            role="img"
            styleName="icon"
            style={{ fontSize: '18px', display: 'block' }}
          >
            help
          </Icon>
        </span>
      </Tooltip>
    </div>
  );
};

FormTooltip.propTypes = {
  children: PropTypes.node
};

export default memo(FormTooltip);
